import React from 'react';
import LoginList from "../components/LoginList";
import {useTranslation} from "react-i18next";

DeleteAccountPage.propTypes = {

};

function DeleteAccountPage() {
    const { t } = useTranslation();
    return (
        <div className="App">
            <h1>{t('deleteAccount.title')}</h1>
            <p>{t('deleteAccount.description')}</p>
            <div className={"d-flex justify-content-center"}>

                <LoginList/>
            </div>
        </div>
    );
}

export default DeleteAccountPage;